import * as React from 'react';

import { Card } from '@mui/material';
import { CancelButton } from 'shared/mui/Buttons';
import { CardActionsButtons, CardHeader } from 'shared/mui/Card';
import { CardContent } from 'shared/mui/Card/CardContent/CardContent';
import { Dialog, DialogProps } from 'shared/mui/Dialogs/Dialog/Dialog';
import { CloseIconButton } from 'shared/mui/IconButtons';
import { Typography } from 'shared/mui/Typography';
import { TypographyBold } from 'shared/mui/Typography/TypographyBold';
import { truncateString } from 'utils/truncateString';

type Props = {
  commissionName: string;
} & DialogProps;

export const CommissionsApproveRefundSuccessDialog: React.FC<Props> = ({
  commissionName,
  ...restProps
}) => {
  return (
    <Dialog {...restProps} fullWidth width="640px">
      <Card>
        <CardHeader
          appendActions={[<CloseIconButton key="close-button" onClose={restProps.onClose} />]}
          title="Создание и согласование комиссий успешно выполнено"
          titleSize="smallBold"
        />
        <CardContent>
          <Typography>
            Новая комиссия{' '}
            <TypographyBold fontSize={16} text={truncateString(commissionName, 30)} /> успешно
            создана в статусе <TypographyBold fontSize={16} text="“Согласована”" />. Дополнительно
            созданы и согласованы отдельные комиссии с типами транзакций &quot;Рефанд&quot; и
            &quot;Чарджбек&quot;. Данные комиссии нельзя редактировать, но, при необходимости, вы
            можете их аннулировать.
          </Typography>
        </CardContent>
        <CardActionsButtons
          rightActionsSlot={
            <CancelButton
              key="back-button"
              label="Вернуться в список"
              onClick={restProps.onClose}
              variant="outlined"
            />
          }
        />
      </Card>
    </Dialog>
  );
};
